import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  JSON_ONE,
  JSON_TWO,
  JSON_THREE,
  JSON_FOUR,
  JSON_FIVE,
  JSON_SIX,
  JSON_SEVEN,
  JSON_EIGHT,
  JSON_NINE,
  JSON_TEN,
  JSON_ELEVEN,
} from "./JSON_DATA_Request";
import {
  JSON_ONE1,
  JSON_TWO2,
  JSON_THREE3,
  JSON_FOUR4,
  JSON_FIVE5,
  JSON_SIX6,
  JSON_SEVEN7,
  JSON_EIGHT8,
  JSON_TEN10,
  JSON_ELEVEN11,
} from "./JSON_DATA_Response";
import {
  JSON_ONE11,
  JSON_TWO12,
  JSON_THREE13,
} from "./JSON_DATA_Requestflowone";
import {
  JSON_ONE21,
  JSON_TWO22,
  JSON_THREE23,
} from "./JSON_DATA_Responseflowone";
import {
  JSON_ONE31,
  JSON_TWO32,
  JSON_THREE33,
} from "./JSON_DATA_Requestflowtwo";
import {
  JSON_ONE41,
  JSON_TWO42,
  JSON_THREE43,
} from "./JSON_DATA_Responseflowtwo";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ReactJson from "react-json-view";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ResponseJSON from "./ResponseJSON";
import RequestJSON from "./RequestJSON";
import ResponseJSONflowone from "./ResponseJSONflowone";
import RequestJSONflowone from "./RequestJSONflowone";
import ResponseJSONflowtwo from "./ResponseJSONflowtwo";
import RequestJSONflowtwo from "./RequestJSONflowtwo";
//import apiFlowLogo from "../../../../../public/assets/images/api-flow-process-img.png";

function PayoutSolution() {
  const [ShowHideAccordion, SetShowHideAccordion] = useState(false);
  const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
  const [ShowHideAccordionThree, SetShowHideAccordionThree] = useState(false);
  const [ShowHideAccordionFour, SetShowHideAccordionFour] = useState(false);
  const [ShowHideAccordionFive, SetShowHideAccordionFive] = useState(false);
  const [ShowHideAccordionSix, SetShowHideAccordionSix] = useState(false);
  const [ShowHideAccordionSeven, SetShowHideAccordionSeven] = useState(false);
  const [ShowHideAccordionEight, SetShowHideAccordionEight] = useState(false);
  const [ShowHideAccordionNine, SetShowHideAccordionNine] = useState(false);
  const [ShowHideAccordionTen, SetShowHideAccordionTen] = useState(false);
  const [ShowHideAccordionEleven, SetShowHideAccordionEleven] = useState(false);
  const [ShowHideAccordionTwelve, SetShowHideAccordionTwelve] = useState(false);
  const [ShowHideAccordionThirteen, SetShowHideAccordionThirteen] =
    useState(false);
  const [ShowHideAccordionFourteen, SetShowHideAccordionFourteen] =
    useState(false);
  const [ShowHideAccordionFiveteen, SetShowHideAccordionFiveteen] =
    useState(false);
  const [ShowHideAccordionSixteen, SetShowHideAccordionSixteen] =
    useState(false);
  const [ShowHideAccordionSeventeen, SetShowHideAccordionSeventeen] =
    useState(false);
  const [ShowHideAccordionEightteen, SetShowHideAccordionEightteen] =
    useState(false);
  const [ShowHideAccordionNineteen, SetShowHideAccordionNineteen] =
    useState(false);
  const [ShowHideAccordionTwenty, SetShowHideAccordionTwenty] = useState(false);
  const [ShowHideAccordionTwentyone, SetShowHideAccordionTwentyone] =
    useState(false);
  const [ShowHideAccordionTwentytwo, SetShowHideAccordionTwentytwo] =
    useState(false);
  const [ShowHideAccordionTwentythree, SetShowHideAccordionTwentythree] =
    useState(false);
  const [ShowHideAccordionTwentyfour, SetShowHideAccordionTwentyfour] =
    useState(false);
  const [ShowHideAccordionTwentyfive, SetShowHideAccordionTwentyfive] =
    useState(false);
  const [ShowHideAccordionTwentysix, SetShowHideAccordionTwentysix] =
    useState(false);
  const [ShowHideAccordionTwentyseven, SetShowHideAccordionTwentyseven] =
    useState(false);
  const [ShowHideAccordionTwentyeight, SetShowHideAccordionTwentyeight] =
    useState(false);
  const [ShowHideAccordionTwentynine, SetShowHideAccordionTwentynine] =
    useState(false);
  const [ShowHideAccordionThirty, SetShowHideAccordionThirty] = useState(false);
  const [ShowHideAccordionThirtyone, SetShowHideAccordionThirtyone] =
    useState(false);
  const [ShowHideAccordionThirtytwo, SetShowHideAccordionThirtytwo] =
    useState(false);
  const [ShowHideAccordionThirtythree, SetShowHideAccordionThirtythree] =
    useState(false);
  const [ShowHideAccordionThirtyfour, SetShowHideAccordionThirtyfour] =
    useState(false);
  const [ShowHideAccordionThirtyfive, SetShowHideAccordionThirtyfive] =
    useState(false);
  const [ShowHideAccordionThirtysix, SetShowHideAccordionThirtysix] =
    useState(false);
  const [ShowHideAccordionThirtyseven, SetShowHideAccordionThirtyseven] =
    useState(false);
  const [ShowHideAccordionThirtyeight, SetShowHideAccordionThirtyeight] =
    useState(false);
  const [ShowHideAccordionThirtynine, SetShowHideAccordionThirtynine] =
    useState(false);
  const [ShowHideAccordionFourty, SetShowHideAccordionFourty] = useState(false);
  const [ShowHideAccordionFourtyone, SetShowHideAccordionFourtyone] =
    useState(false);
  const [ShowHideAccordionFourtytwo, SetShowHideAccordionFourtytwo] =
    useState(false);
  const [ShowHideAccordionFourtythree, SetShowHideAccordionFourtythree] =
    useState(false);
  const [ShowHideAccordionFourtyfour, SetShowHideAccordionFourtyfour] =
    useState(false);
  const [ShowHideAccordionFourtyfive, SetShowHideAccordionFourtyfive] =
    useState(false);
  const [ShowHideAccordionFourtysix, SetShowHideAccordionFourtysix] =
    useState(false);
  const [ShowHideAccordionFourtyseven, SetShowHideAccordionFourtyseven] =
    useState(false);
  const [ShowHideAccordionFourtyeight, SetShowHideAccordionFourtyeight] =
    useState(false);
  const [ShowHideAccordionFourtynine, SetShowHideAccordionFourtynine] =
    useState(false);
  const [ShowHideAccordionFifty, SetShowHideAccordionFifty] = useState(false);
  const [ShowHideAccordionFiftyone, SetShowHideAccordionFiftyone] =
    useState(false);
  const [ShowHideAccordionFiftytwo, SetShowHideAccordionFiftytwo] =
    useState(false);
  const [ShowHideAccordionFiftythree, SetShowHideAccordionFiftythree] =
    useState(false);
  const [ShowHideAccordionFiftyfour, SetShowHideAccordionFiftyfour] =
    useState(false);
  const [ShowHideAccordionFiftyfive, SetShowHideAccordionFiftyfive] =
    useState(false);
  const [ShowHideAccordionFiftysix, SetShowHideAccordionFiftysix] =
    useState(false);
  const [ShowHideAccordionFiftyseven, SetShowHideAccordionFiftyseven] =
    useState(false);
  const [ShowHideAccordionFiftyeight, SetShowHideAccordionFiftyeight] =
    useState(false);
  const [ShowHideAccordionFiftynine, SetShowHideAccordionFiftynine] =
    useState(false);
  const [ShowHideAccordionSixtyone, SetShowHideAccordionSixtyone] =
    useState(false);
  const [ShowHideAccordionSixtytwo, SetShowHideAccordionSixtytwo] =
    useState(false);
  const [ShowHideAccordionSixtythree, SetShowHideAccordionSixtythree] =
    useState(false);
  const [ShowHideAccordionSixtyfour, SetShowHideAccordionSixtyfour] =
    useState(false);
  const [ShowHideAccordionSixtyfive, SetShowHideAccordionSixtyfive] =
    useState(false);
  const [ShowHideAccordionSixtysix, SetShowHideAccordionSixtysix] =
    useState(false);
  const [ShowHideAccordionSixtyseven, SetShowHideAccordionSixtyseven] =
    useState(false);
  const [ShowHideAccordionSixtyeight, SetShowHideAccordionSixtyeight] =
    useState(false);
  const [ShowHideAccordionSixtynine, SetShowHideAccordionSixtynine] =
    useState(false);
  const [ShowHideAccordionSeventy, SetShowHideAccordionSeventy] =
    useState(false);
  const [ShowHideAccordionSeventyone, SetShowHideAccordionSeventyone] =
    useState(false);
  const [ShowHideAccordionSeventytwo, SetShowHideAccordionSeventytwo] =
    useState(false);
  const [ShowHideAccordionSeventythree, SetShowHideAccordionSeventythree] =
    useState(false);
  const [ShowHideAccordionSeventyfour, SetShowHideAccordionSeventyfour] =
    useState(false);
  const [ShowHideAccordionSeventyfive, SetShowHideAccordionSeventyfive] =
    useState(false);
  const [ShowHideAccordionSeventysix, SetShowHideAccordionSeventysix] =
    useState(false);
  const [ShowHideAccordionSeventyseven, SetShowHideAccordionSeventyseven] =
    useState(false);
  const [ShowHideAccordionSeventyeight, SetShowHideAccordionSeventyeight] =
    useState(false);
  const [ShowHideAccordionSeventynine, SetShowHideAccordionSeventynine] =
    useState(false);
  const [ShowHideAccordionEighty, SetShowHideAccordionEighty] = useState(false);
  const [ShowHideAccordionEightyone, SetShowHideAccordionEightyone] =
    useState(false);
  const [ShowHideAccordionEightytwo, SetShowHideAccordionEightytwo] =
    useState(false);
  const [ShowHideAccordionEightythree, SetShowHideAccordionEightythree] =
    useState(false);
  const [ShowHideAccordionEightyfour, SetShowHideAccordionEightyfour] =
    useState(false);
  const [ShowHideAccordionEightyfive, SetShowHideAccordionEightyfive] =
    useState(false);
  const [ShowHideAccordionEightysix, SetShowHideAccordionEightysix] =
    useState(false);
  const [ShowHideAccordionEightyseven, SetShowHideAccordionEightyseven] =
    useState(false);
  const [ShowHideAccordionEightyeight, SetShowHideAccordionEightyeight] =
    useState(false);
  const [ShowHideAccordionEightynine, SetShowHideAccordionEightynine] =
    useState(false);
  const [ShowHideAccordionNinety, SetShowHideAccordionNinety] = useState(false);
  const [ShowHideAccordionNinetyone, SetShowHideAccordionNinetyone] =
    useState(false);
  const [ShowHideAccordionNinetytwo, SetShowHideAccordionNinetytwo] =
    useState(false);
  const [ShowHideAccordionNinetythree, SetShowHideAccordionNinetythree] =
    useState(false);
  const [ShowHideAccordionNinetyfour, SetShowHideAccordionNinetyfour] =
    useState(false);
  const [ShowHideAccordionNinetyfive, SetShowHideAccordionNinetyfive] =
    useState(false);
  const [ShowHideAccordionNinetysix, SetShowHideAccordionNinetysix] =
    useState(false);
  const [ShowHideAccordionNinetyseven, SetShowHideAccordionNinetyseven] =
    useState(false);
  const [ShowHideAccordionNinetyeight, SetShowHideAccordionNinetyeight] =
    useState(false);
  const [ShowHideAccordionNinetynine, SetShowHideAccordionNinetynine] =
    useState(false);
  const [ShowHideAccordionHundred, SetShowHideAccordionHundred] =
    useState(false);
  const [ShowHideAccordionHundredone, SetShowHideAccordionHundredone] =
    useState(false);
  const [ShowHideAccordionHundredtwo, SetShowHideAccordionHundredtwo] =
    useState(false);
  const [ShowHideAccordionHundredthree, SetShowHideAccordionHundredthree] =
    useState(false);
  const [ShowHideAccordionHundredfour, SetShowHideAccordionHundredfour] =
    useState(false);
  const [ShowHideAccordionHundredfive, SetShowHideAccordionHundredfive] =
    useState(false);
  const [ShowHideAccordionHundredsix, SetShowHideAccordionHundredsix] =
    useState(false);
  const [ShowHideAccordionHundredseven, SetShowHideAccordionHundredseven] =
    useState(false);
  const [ShowHideAccordionHundredeight, SetShowHideAccordionHundredeight] =
    useState(false);
  const [ShowHideAccordionHundrednine, SetShowHideAccordionHundrednine] =
    useState(false);
  const [ShowHideAccordionHundredten, SetShowHideAccordionHundredten] =
    useState(false);
  const [ShowHideAccordionHundredeleven, SetShowHideAccordionHundredeleven] =
    useState(false);
  const [ShowHideAccordionHundredtwelve, SetShowHideAccordionHundredtwelve] =
    useState(false);
  const onClickAccordianShowHide = () => {
    SetShowHideAccordion(!ShowHideAccordion);
  };
  const onClickAccordianShowHideTwo = () => {
    SetShowHideAccordionTwo(!ShowHideAccordionTwo);
  };
  const onClickAccordianShowHideThree = () => {
    SetShowHideAccordionThree(!ShowHideAccordionThree);
  };
  const onClickAccordianShowHideFour = () => {
    SetShowHideAccordionFour(!ShowHideAccordionFour);
  };
  const onClickAccordianShowHideFive = () => {
    SetShowHideAccordionFive(!ShowHideAccordionFive);
  };
  const onClickAccordianShowHideSix = () => {
    SetShowHideAccordionSix(!ShowHideAccordionSix);
  };
  const onClickAccordianShowHideSeven = () => {
    SetShowHideAccordionSeven(!ShowHideAccordionSeven);
  };
  const onClickAccordianShowHideEight = () => {
    SetShowHideAccordionEight(!ShowHideAccordionEight);
  };
  const onClickAccordianShowHideNine = () => {
    SetShowHideAccordionNine(!ShowHideAccordionNine);
  };
  const onClickAccordianShowHideTen = () => {
    SetShowHideAccordionTen(!ShowHideAccordionTen);
  };
  const onClickAccordianShowHideEleven = () => {
    SetShowHideAccordionEleven(!ShowHideAccordionEleven);
  };
  const onClickAccordianShowHideTwelve = () => {
    SetShowHideAccordionTwelve(!ShowHideAccordionTwelve);
  };
  const onClickAccordianShowHideThirteen = () => {
    SetShowHideAccordionThirteen(!ShowHideAccordionThirteen);
  };
  const onClickAccordianShowHideFourteen = () => {
    SetShowHideAccordionFourteen(!ShowHideAccordionFourteen);
  };
  const onClickAccordianShowHideFiveteen = () => {
    SetShowHideAccordionFiveteen(!ShowHideAccordionFiveteen);
  };
  const onClickAccordianShowHideSixteen = () => {
    SetShowHideAccordionSixteen(!ShowHideAccordionSixteen);
  };
  const onClickAccordianShowHideSeventeen = () => {
    SetShowHideAccordionSeventeen(!ShowHideAccordionSeventeen);
  };
  const onClickAccordianShowHideEightteen = () => {
    SetShowHideAccordionEightteen(!ShowHideAccordionEightteen);
  };
  const onClickAccordianShowHideNineteen = () => {
    SetShowHideAccordionNineteen(!ShowHideAccordionNineteen);
  };
  const onClickAccordianShowHideTwenty = () => {
    SetShowHideAccordionTwenty(!ShowHideAccordionTwenty);
  };
  const onClickAccordianShowHideTwentyone = () => {
    SetShowHideAccordionTwentyone(!ShowHideAccordionTwentyone);
  };
  const onClickAccordianShowHideTwentytwo = () => {
    SetShowHideAccordionTwentytwo(!ShowHideAccordionTwentytwo);
  };
  const onClickAccordianShowHideTwentythree = () => {
    SetShowHideAccordionTwentythree(!ShowHideAccordionTwentythree);
  };
  const onClickAccordianShowHideTwentyfour = () => {
    SetShowHideAccordionTwentyfour(!ShowHideAccordionTwentyfour);
  };
  const onClickAccordianShowHideTwentyfive = () => {
    SetShowHideAccordionTwentyfive(!ShowHideAccordionTwentyfive);
  };
  const onClickAccordianShowHideTwentysix = () => {
    SetShowHideAccordionTwentysix(!ShowHideAccordionTwentysix);
  };
  const onClickAccordianShowHideTwentyseven = () => {
    SetShowHideAccordionTwentyseven(!ShowHideAccordionTwentyseven);
  };
  const onClickAccordianShowHideTwentyeight = () => {
    SetShowHideAccordionTwentyeight(!ShowHideAccordionTwentyeight);
  };
  const onClickAccordianShowHideTwentynine = () => {
    SetShowHideAccordionTwentynine(!ShowHideAccordionTwentynine);
  };
  const onClickAccordianShowHideThirty = () => {
    SetShowHideAccordionThirty(!ShowHideAccordionThirty);
  };
  const onClickAccordianShowHideThirtyone = () => {
    SetShowHideAccordionThirtyone(!ShowHideAccordionThirtyone);
  };
  const onClickAccordianShowHideThirtytwo = () => {
    SetShowHideAccordionThirtytwo(!ShowHideAccordionThirtytwo);
  };
  const onClickAccordianShowHideThirtythree = () => {
    SetShowHideAccordionThirtythree(!ShowHideAccordionThirtythree);
  };
  const onClickAccordianShowHideThirtyfour = () => {
    SetShowHideAccordionThirtyfour(!ShowHideAccordionThirtyfour);
  };
  const onClickAccordianShowHideThirtyfive = () => {
    SetShowHideAccordionThirtyfive(!ShowHideAccordionThirtyfive);
  };
  const onClickAccordianShowHideThirtysix = () => {
    SetShowHideAccordionThirtysix(!ShowHideAccordionThirtysix);
  };
  const onClickAccordianShowHideThirtyseven = () => {
    SetShowHideAccordionThirtyseven(!ShowHideAccordionThirtyseven);
  };
  const onClickAccordianShowHideThirtyeight = () => {
    SetShowHideAccordionThirtyeight(!ShowHideAccordionThirtyeight);
  };
  const onClickAccordianShowHideThirtynine = () => {
    SetShowHideAccordionThirtynine(!ShowHideAccordionThirtynine);
  };
  const onClickAccordianShowHideFourty = () => {
    SetShowHideAccordionFourty(!ShowHideAccordionFourty);
  };
  const onClickAccordianShowHideFourtyone = () => {
    SetShowHideAccordionFourtyone(!ShowHideAccordionFourtyone);
  };
  const onClickAccordianShowHideFourtytwo = () => {
    SetShowHideAccordionFourtytwo(!ShowHideAccordionFourtytwo);
  };
  const onClickAccordianShowHideFourtythree = () => {
    SetShowHideAccordionFourtythree(!ShowHideAccordionFourtythree);
  };
  const onClickAccordianShowHideFourtyfour = () => {
    SetShowHideAccordionFourtyfour(!ShowHideAccordionFourtyfour);
  };
  const onClickAccordianShowHideFourtyfive = () => {
    SetShowHideAccordionFourtyfive(!ShowHideAccordionFourtyfive);
  };
  const onClickAccordianShowHideFourtysix = () => {
    SetShowHideAccordionFourtysix(!ShowHideAccordionFourtysix);
  };
  const onClickAccordianShowHideFourtyseven = () => {
    SetShowHideAccordionFourtyseven(!ShowHideAccordionFourtyseven);
  };
  const onClickAccordianShowHideFourtyeight = () => {
    SetShowHideAccordionFourtyeight(!ShowHideAccordionFourtyeight);
  };
  const onClickAccordianShowHideFourtynine = () => {
    SetShowHideAccordionFourtynine(!ShowHideAccordionFourtynine);
  };
  const onClickAccordianShowHideFifty = () => {
    SetShowHideAccordionFifty(!ShowHideAccordionFifty);
  };
  const onClickAccordianShowHideFiftyone = () => {
    SetShowHideAccordionFiftyone(!ShowHideAccordionFiftyone);
  };
  const onClickAccordianShowHideFiftytwo = () => {
    SetShowHideAccordionFiftytwo(!ShowHideAccordionFiftytwo);
  };
  const onClickAccordianShowHideFiftythree = () => {
    SetShowHideAccordionFiftythree(!ShowHideAccordionFiftythree);
  };
  const onClickAccordianShowHideFiftyfour = () => {
    SetShowHideAccordionFiftyfour(!ShowHideAccordionFiftyfour);
  };
  const onClickAccordianShowHideFiftyfive = () => {
    SetShowHideAccordionFiftyfive(!ShowHideAccordionFiftyfive);
  };
  const onClickAccordianShowHideFiftysix = () => {
    SetShowHideAccordionFiftysix(!ShowHideAccordionFiftysix);
  };
  const onClickAccordianShowHideFiftyseven = () => {
    SetShowHideAccordionFiftyseven(!ShowHideAccordionFiftyseven);
  };
  const onClickAccordianShowHideFiftyeight = () => {
    SetShowHideAccordionFiftyeight(!ShowHideAccordionFiftyeight);
  };
  const onClickAccordianShowHideFiftynine = () => {
    SetShowHideAccordionFiftynine(!ShowHideAccordionFiftynine);
  };
  const onClickAccordianShowHideSixtyone = () => {
    SetShowHideAccordionSixtyone(!ShowHideAccordionSixtyone);
  };
  const onClickAccordianShowHideSixtytwo = () => {
    SetShowHideAccordionSixtytwo(!ShowHideAccordionSixtytwo);
  };
  const onClickAccordianShowHideSixtythree = () => {
    SetShowHideAccordionSixtythree(!ShowHideAccordionSixtythree);
  };
  const onClickAccordianShowHideSixtyfour = () => {
    SetShowHideAccordionSixtyfour(!ShowHideAccordionSixtyfour);
  };
  const onClickAccordianShowHideSixtyfive = () => {
    SetShowHideAccordionSixtyfive(!ShowHideAccordionSixtyfive);
  };
  const onClickAccordianShowHideSixtysix = () => {
    SetShowHideAccordionSixtysix(!ShowHideAccordionSixtysix);
  };
  const onClickAccordianShowHideSixtyseven = () => {
    SetShowHideAccordionSixtyseven(!ShowHideAccordionSixtyseven);
  };
  const onClickAccordianShowHideSixtyeight = () => {
    SetShowHideAccordionSixtyeight(!ShowHideAccordionSixtyeight);
  };
  const onClickAccordianShowHideSixtynine = () => {
    SetShowHideAccordionSixtynine(!ShowHideAccordionSixtynine);
  };
  const onClickAccordianShowHideSeventy = () => {
    SetShowHideAccordionSeventy(!ShowHideAccordionSeventy);
  };
  const onClickAccordianShowHideSeventyone = () => {
    SetShowHideAccordionSeventyone(!ShowHideAccordionSeventyone);
  };
  const onClickAccordianShowHideSeventytwo = () => {
    SetShowHideAccordionSeventytwo(!ShowHideAccordionSeventytwo);
  };
  const onClickAccordianShowHideSeventythree = () => {
    SetShowHideAccordionSeventythree(!ShowHideAccordionSeventythree);
  };
  const onClickAccordianShowHideSeventyfour = () => {
    SetShowHideAccordionSeventyfour(!ShowHideAccordionSeventyfour);
  };
  const onClickAccordianShowHideSeventyfive = () => {
    SetShowHideAccordionSeventyfive(!ShowHideAccordionSeventyfive);
  };
  const onClickAccordianShowHideSeventysix = () => {
    SetShowHideAccordionSeventysix(!ShowHideAccordionSeventysix);
  };
  const onClickAccordianShowHideSeventyseven = () => {
    SetShowHideAccordionSeventyseven(!ShowHideAccordionSeventyseven);
  };
  const onClickAccordianShowHideSeventyeight = () => {
    SetShowHideAccordionSeventyeight(!ShowHideAccordionSeventyeight);
  };
  const onClickAccordianShowHideSeventynine = () => {
    SetShowHideAccordionSeventynine(!ShowHideAccordionSeventynine);
  };
  const onClickAccordianShowHideEighty = () => {
    SetShowHideAccordionEighty(!ShowHideAccordionEighty);
  };
  const onClickAccordianShowHideEightyone = () => {
    SetShowHideAccordionEightyone(!ShowHideAccordionEightyone);
  };
  const onClickAccordianShowHideEightytwo = () => {
    SetShowHideAccordionEightytwo(!ShowHideAccordionEightytwo);
  };
  const onClickAccordianShowHideEightythree = () => {
    SetShowHideAccordionEightythree(!ShowHideAccordionEightythree);
  };
  const onClickAccordianShowHideEightyfour = () => {
    SetShowHideAccordionEightyfour(!ShowHideAccordionEightyfour);
  };
  const onClickAccordianShowHideEightyfive = () => {
    SetShowHideAccordionEightyfive(!ShowHideAccordionEightyfive);
  };
  const onClickAccordianShowHideEightysix = () => {
    SetShowHideAccordionEightysix(!ShowHideAccordionEightysix);
  };
  const onClickAccordianShowHideEightyseven = () => {
    SetShowHideAccordionEightyseven(!ShowHideAccordionEightyseven);
  };
  const onClickAccordianShowHideEightyeight = () => {
    SetShowHideAccordionEightyeight(!ShowHideAccordionEightyeight);
  };
  const onClickAccordianShowHideEightynine = () => {
    SetShowHideAccordionEightynine(!ShowHideAccordionEightynine);
  };
  const onClickAccordianShowHideNinety = () => {
    SetShowHideAccordionNinety(!ShowHideAccordionNinety);
  };
  const onClickAccordianShowHideNinetyone = () => {
    SetShowHideAccordionNinetyone(!ShowHideAccordionNinetyone);
  };
  const onClickAccordianShowHideNinetytwo = () => {
    SetShowHideAccordionNinetytwo(!ShowHideAccordionNinetytwo);
  };
  const onClickAccordianShowHideNinetythree = () => {
    SetShowHideAccordionNinetythree(!ShowHideAccordionNinetythree);
  };
  const onClickAccordianShowHideNinetyfour = () => {
    SetShowHideAccordionNinetyfour(!ShowHideAccordionNinetyfour);
  };
  const onClickAccordianShowHideNinetyfive = () => {
    SetShowHideAccordionNinetyfive(!ShowHideAccordionNinetyfive);
  };
  const onClickAccordianShowHideNinetysix = () => {
    SetShowHideAccordionNinetysix(!ShowHideAccordionNinetysix);
  };
  const onClickAccordianShowHideNinetyseven = () => {
    SetShowHideAccordionNinetyseven(!ShowHideAccordionNinetyseven);
  };
  const onClickAccordianShowHideNinetyeight = () => {
    SetShowHideAccordionNinetyeight(!ShowHideAccordionNinetyeight);
  };
  const onClickAccordianShowHideNinetynine = () => {
    SetShowHideAccordionNinetynine(!ShowHideAccordionNinetynine);
  };
  const onClickAccordianShowHideHundred = () => {
    SetShowHideAccordionHundred(!ShowHideAccordionHundred);
  };
  const onClickAccordianShowHideHundredone = () => {
    SetShowHideAccordionHundredone(!ShowHideAccordionHundredone);
  };
  const onClickAccordianShowHideHundredtwo = () => {
    SetShowHideAccordionHundredtwo(!ShowHideAccordionHundredtwo);
  };
  const onClickAccordianShowHideHundredthree = () => {
    SetShowHideAccordionHundredthree(!ShowHideAccordionHundredthree);
  };
  const onClickAccordianShowHideHundredfour = () => {
    SetShowHideAccordionHundredfour(!ShowHideAccordionHundredfour);
  };
  const onClickAccordianShowHideHundredfive = () => {
    SetShowHideAccordionHundredfive(!ShowHideAccordionHundredfive);
  };
  const onClickAccordianShowHideHundredsix = () => {
    SetShowHideAccordionHundredsix(!ShowHideAccordionHundredsix);
  };
  const onClickAccordianShowHideHundredseven = () => {
    SetShowHideAccordionHundredseven(!ShowHideAccordionHundredseven);
  };
  const onClickAccordianShowHideHundredeight = () => {
    SetShowHideAccordionHundredeight(!ShowHideAccordionHundredeight);
  };
  const onClickAccordianShowHideHundrednine = () => {
    SetShowHideAccordionHundrednine(!ShowHideAccordionHundrednine);
  };
  const onClickAccordianShowHideHundredten = () => {
    SetShowHideAccordionHundredten(!ShowHideAccordionHundredten);
  };
  const onClickAccordianShowHideHundredeleven = () => {
    SetShowHideAccordionHundredeleven(!ShowHideAccordionHundredeleven);
  };
  const onClickAccordianShowHideHundredtwelve = () => {
    SetShowHideAccordionHundredtwelve(!ShowHideAccordionHundredtwelve);
  };
  const [FourTabSelect, SetFourTabSelect] = useState(1);
  const [FourTabSelect1, SetFourTabSelect1] = useState(2);
  const [FourTabSelect2, SetFourTabSelect2] = useState(3);
  const [FourTabSelect3, SetFourTabSelect3] = useState(3);
  const [FourTabSelect4, SetFourTabSelect4] = useState(3);
  const [FourTabSelect5, SetFourTabSelect5] = useState(3);
  const [FourTabSelect6, SetFourTabSelect6] = useState(3);
  const [FourTabSelect7, SetFourTabSelect7] = useState(3);
  const [TabCheck, SetTabCheck] = useState(false);
  const [TabCheck1, SetTabCheck1] = useState(false);
  const [TabCheck2, SetTabCheck2] = useState(false);
  const [TabCheck3, SetTabCheck3] = useState(false);
  const [TabCheck4, SetTabCheck4] = useState(false);
  const [TabCheck5, SetTabCheck5] = useState(false);
  const [TabCheck6, SetTabCheck6] = useState(false);
  const [TabCheck7, SetTabCheck7] = useState(false);
  const onClickCangeTab = () => {
    SetTabCheck(!TabCheck);
  };
  const onClickCangeTab1 = () => {
    SetTabCheck1(!TabCheck1);
  };
  const onClickCangeTab2 = () => {
    SetTabCheck2(!TabCheck2);
  };
  const onClickCangeTab3 = () => {
    SetTabCheck3(!TabCheck3);
  };
  const onClickCangeTab4 = () => {
    SetTabCheck4(!TabCheck4);
  };
  const onClickCangeTab5 = () => {
    SetTabCheck5(!TabCheck5);
  };
  const onClickCangeTab6 = () => {
    SetTabCheck6(!TabCheck6);
  };
  const onClickCangeTab7 = () => {
    SetTabCheck7(!TabCheck7);
  };
  const ShowFourTab = () => {
    if (FourTabSelect == 1) {
      return (
        <div id="versionCheck" class="mt-10">
          <h3>versionCheckRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHide}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header {ShowHideAccordion ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordion && (
                <tr>
                  <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Send Aggregator id.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Current version of APP.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  className="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="pg_details"
                  onClick={onClickAccordianShowHideTwo}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionTwo ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td className="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwo && (
                <tr>
                  <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “ONBO”.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “CHECK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="tranCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>tranCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “CHECK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 2) {
      return (
        <div id="loadMoney" class="mt-10">
          <h3>loadMoneyRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThree}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionThree ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThree && (
                <tr>
                  <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFour}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionFour ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFour && (
                <tr>
                  <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “LMREQ”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFive}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    loadMoneyModel{" "}
                    {ShowHideAccordionFive ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFive && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Enter transaction Amount upto 2 decimal
                                      places.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Enter Bank reference number</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="createdBy"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>createdBy</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Enter Aggregator/ Distributor id (starting
                                      with AGGR.../DIST...)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 3) {
      return (
        <div id="loadMoneyList" class="mt-10">
          <h3>loadMoneyListRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSix}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionSix ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSix && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeven}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionSeven ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “ONBO”.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “CHECK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEight}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    loadMoneyModel{" "}
                    {ShowHideAccordionEight ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEight && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="usertype"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>usertype</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 4) {
      return (
        <div id="getBene" class="mt-10">
          <h3>getBeneficiaryListRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNine}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionNine ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTen}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionTen ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTen && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as BENEL</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 5) {
      return (
        <div id="getBene" class="mt-10">
          <h3>validateOTPReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEleven}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionEleven ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEleven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>userInfo</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwelve}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionTwelve ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwelve && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “PWTB”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="otp"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>otp</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>OTP send on register mobile no</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="otp_ref_number"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>otp_ref_number</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Received in previous API’s response</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirteen}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionThirteen ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirteen && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Transaction Amount.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Bank Account no in which amount will be
                                      credited.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IFSC Code (11 Characters only)</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Name of Bank without spaces (eg:HDFCBank)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Paymode with which transaction should
                                      happen: IMPS, UPI
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="orderRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>orderRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Client need to share Transaction Id.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 6) {
      return (
        <div id="getBene" class="mt-10">
          <h3>transactionsByDayReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourteen}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionFourteen ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourteen && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>userInfo</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiveteen}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionFiveteen ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiveteen && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “PWTB”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="tranCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>tranCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixteen}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionSixteen ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixteen && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="StartDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>StartDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="EndDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>EndDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 7) {
      return (
        <div id="getBene" class="mt-10">
          <h3>transactionsByCustomerIdReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventeen}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionSeventeen ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventeen && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="StartDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>StartDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="EndDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>EndDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEightteen}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionEightteen ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightteen && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTAL”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="tranCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>tranCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNineteen}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionNineteen ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNineteen && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Client’s id as shared by the Safexpay
                                      team, shall bebeginning with “AGGR” or
                                      “DIST” ,or “CUST”
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 8) {
      return (
        <div id="getBene" class="mt-10">
          <h3>transactionsByTransactionIdReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwenty}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionTwenty ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwenty && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentyone}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionTwentyone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentyone && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTAL”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="tranCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>tranCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentytwo}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionTwentytwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentytwo && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Client’s id as shared by the Safexpay
                                      team, shall bebeginning with “AGGR” or
                                      “DIST” ,or “CUST”
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="orderRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>orderRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Client needs to share the transaction id
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 9) {
      return (
        <div id="getBene" class="mt-10">
          <h3>transactionStatusCheckReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentythree}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionTwentythree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentythree && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentyfour}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionTwentyfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentyfour && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “STCHK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentyfive}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionTwentyfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentyfive && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="payoutId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>payoutId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass the payout id for which you intend to
                                      know the final status
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 10) {
      return (
        <div id="getBene" class="mt-10">
          <h3>fetchBalanceRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentysix}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionTwentysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentysix && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>userInfo </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentyseven}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionTwentyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentyseven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as WTW</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as "GPWB"</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentyeight}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    preLoadingWallet{" "}
                    {ShowHideAccordionTwentyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentyeight && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="walletType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>walletType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 11) {
      return (
        <div id="getBene" class="mt-10">
          <h3>fetchOtherBalanceRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentysix}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionTwentysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentysix && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>userInfo </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentyseven}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionTwentyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentyseven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as WTW</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as "GPWB"</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentyeight}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    preLoadingWallet{" "}
                    {ShowHideAccordionTwentyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentyeight && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="walletType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>walletType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else {
      return <div>No Data</div>;
    }
  };
  //
  const ShowFourTab1 = () => {
    if (FourTabSelect == 1) {
      return (
        <div id="versionCheck" class="mt-10">
          <h3>versionCheckResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideTwentynine}
                >
                  <span className="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionTwentynine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionTwentynine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Send Aggregator id</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Current version of APP</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="key"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>key</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideThirty}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionThirty ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirty && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “ONBO”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “CHECK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="tranCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>tranCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>userInfo </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideThirtyone}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionThirtyone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtyone && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 2) {
      return (
        <div id="loadMoney" class="mt-10">
          <h3>loadMoneyResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirtytwo}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionThirtytwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtytwo && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirtythree}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionThirtythree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtythree && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirtyfour}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionThirtyfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtyfour && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirtyfive}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    loadMoneyModel{" "}
                    {ShowHideAccordionThirtyfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtyfive && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="aggregatorId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>aggregatorId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Enter transaction Amount upto 2 decimal
                                      places.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="status"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>status</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Enter transaction Amount upto 2 decimal
                                      places.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="createdBy"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>createdBy</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Enter Aggregator/ Distributor id (starting
                                      with AGGR.../DIST...)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “CHECK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="responseCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>responseCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “CHECK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="responseMsg"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>responseMsg</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “CHECK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 3) {
      return (
        <div id="loadMoneyList" class="mt-10">
          <h3>loadMoneyListResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirtysix}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionThirtysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtysix && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirtyseven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionThirtyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtyseven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “LMSL”.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Send in serviceReqRes</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirtyeight}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionThirtyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtyeight && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideThirtynine}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    loadMoneyModel{" "}
                    {ShowHideAccordionThirtynine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionThirtynine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="usertype"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>usertype</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourty}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    loadMoneyReqList{" "}
                    {ShowHideAccordionFourty ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourty && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <div>
                        <div class="sc-bCwfaz ilMEYI"> Array ()</div>
                        <div class="sc-jQAxuV NAoOF">
                          <table class="sc-hHEiqL iZJLLY">
                            <tbody>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="walletId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>walletId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnAmount"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnAmount</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>
                                          Enter transaction Amount upto 2
                                          decimal places.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="status"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>status</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>
                                          Enter transaction Amount upto 2
                                          decimal places.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="creationDate"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>creationDate</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="usertype"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>usertype</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="modifiedBy"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>modifiedBy</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>
                                          Enter Aggregator/ Distributor id
                                          (starting with AGGR.../DIST...)
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="createdBy"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>createdBy</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>
                                          Enter Aggregator/ Distributor id
                                          (starting with AGGR.../DIST...)
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="last undefined">
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="userId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>userId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="sc-iwajpm bcEyfL"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 4) {
      return (
        <div id="getBene" class="mt-10">
          <h3>getBeneficiaryListResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtyone}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionFourtyone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtyone && (
                <tr className="expanded ">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtytwo}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionFourtytwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtytwo && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “BENEF”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Send in serviceReqRes</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtythree}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    beneList{" "}
                    {ShowHideAccordionFourtythree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        {" "}
                        Array of objects
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtythree && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <div>
                        <div class="sc-bCwfaz ilMEYI"> Array ()</div>
                        <div class="sc-jQAxuV NAoOF">
                          <table class="sc-hHEiqL iZJLLY">
                            <tbody>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="id"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>id</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="beneId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>beneId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Bene mobile no.</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="name"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>name</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="nickName"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>nickName</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="aggregatorId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>aggregatorId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="userId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>userId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="ifscCOde"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>ifscCOde</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Bene Name</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="beneStatus"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>beneStatus</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="mobileNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>mobileNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Bene Name</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="addBy"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>addBy</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="last undefined">
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="virtualAddress"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>virtualAddress</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="sc-iwajpm bcEyfL"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 5) {
      return (
        <div id="getBene" class="mt-10">
          <h3>validateOTPReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtyfour}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionFourtyfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtyfour && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtyfive}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionFourtyfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtyfive && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “PWTB”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="otp"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>otp</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="otp_ref_number"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>otp_ref_number</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Send in serviceReqRes</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtysix}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionFourtysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtysix && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtyseven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionFourtyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtyseven && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="payoutId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>payoutId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Transaction Amount.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Bank Account no in which amount will be
                                      credited.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IFSC Code</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Name of Bank</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IMPS, UPI</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="aggregatorId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>aggregatorId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Saving, Current</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="spkRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>spkRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusDesc"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusDesc</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 6) {
      return (
        <div id="getBene" class="mt-10">
          <h3>transactionsByDayRes</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtyeight}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionFourtyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtyeight && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFourtynine}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionFourtynine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFourtynine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTAL”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFifty}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionFifty ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFifty && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftyone}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionFiftyone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftyone && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="StartDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>StartDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="EndDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>EndDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftytwo}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutList{" "}
                    {ShowHideAccordionFiftytwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftytwo && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <div>
                        <div class="sc-bCwfaz ilMEYI"> Array ()</div>
                        <div class="sc-jQAxuV NAoOF">
                          <table class="sc-hHEiqL iZJLLY">
                            <tbody>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="payoutId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>payoutId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="mobileNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>mobileNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Users register mobile no.</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="customerId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>customerId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnAmount"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnAmount</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Transaction Amount.</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>
                                          Bank Account no in which amount will
                                          be credited.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="ifscCode"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>ifscCode</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>IFSC Code</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankName"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankName</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Name of Bank</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountHolderName"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountHolderName</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Users register name</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnType"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnType</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>IMPS, UPI</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="aggregatorId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>aggregatorId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountType"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountType</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Saving, Current</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnStatus"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnStatus</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankRefNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankRefNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="spkRefNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>spkRefNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankStatus"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankStatus</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="statusCode"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>statusCode</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="statusDesc"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>statusDesc</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="last undefined">
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnDate"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnDate</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="sc-iwajpm bcEyfL"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 7) {
      return (
        <div id="getBene" class="mt-10">
          <h3>transactionsByCustomerIdRes</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftythree}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionFiftythree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftythree && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>userInfo</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftyfour}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionFiftyfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftyfour && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTAL”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftyfive}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionFiftyfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftyfive && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftysix}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionFiftysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftysix && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Client’s id as shared by the Safexpay
                                      team, shall bebeginning with “AGGR” or
                                      “DIST” ,or “CUST”
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftyseven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutList{" "}
                    {ShowHideAccordionFiftyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftyseven && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <div>
                        <div class="sc-bCwfaz ilMEYI"> Array ()</div>
                        <div class="sc-jQAxuV NAoOF">
                          <table class="sc-hHEiqL iZJLLY">
                            <tbody>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="payoutId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>payoutId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="mobileNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>mobileNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Users register mobile no.</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="customerId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>customerId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnAmount"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnAmount</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Transaction Amount.</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>
                                          Bank Account no in which amount will
                                          be credited.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="ifscCode"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>ifscCode</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>IFSC Code</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankName"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankName</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Name of Bank</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountHolderName"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountHolderName</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Users register name</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnType"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnType</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>IMPS, UPI</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="aggregatorId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>aggregatorId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountType"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountType</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Saving, Current</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnStatus"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnStatus</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankRefNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankRefNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="spkRefNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>spkRefNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankStatus"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankStatus</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="statusCode"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>statusCode</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="statusDesc"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>statusDesc</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="last undefined">
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnDate"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnDate</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="sc-iwajpm bcEyfL"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 8) {
      return (
        <div id="getBene" class="mt-10">
          <h3>transactionsByTransactionIdRes</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftyeight}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionFiftyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftyeight && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>userInfo</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideFiftynine}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionFiftynine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionFiftynine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTAL”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtyone}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionSixtyone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtyone && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Client’s id as shared by the Safexpay
                                      team, shall bebeginning with “AGGR” or
                                      “DIST” ,or “CUST”
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="orderRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>orderRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Client needs to share the transaction id
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtytwo}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutList{" "}
                    {ShowHideAccordionSixtytwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtytwo && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <div>
                        <div class="sc-bCwfaz ilMEYI"> Array ()</div>
                        <div class="sc-jQAxuV NAoOF">
                          <table class="sc-hHEiqL iZJLLY">
                            <tbody>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="payoutId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>payoutId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="mobileNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>mobileNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Users register mobile no.</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="customerId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>customerId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnAmount"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnAmount</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Transaction Amount.</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>
                                          Bank Account no in which amount will
                                          be credited.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="ifscCode"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>ifscCode</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>IFSC Code</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankName"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankName</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Name of Bank</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountHolderName"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountHolderName</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Users register name</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnType"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnType</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>IMPS, UPI</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="aggregatorId"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>aggregatorId</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="accountType"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>accountType</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Saving, Current</p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnStatus"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnStatus</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankRefNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankRefNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="spkRefNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>spkRefNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="bankStatus"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>bankStatus</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="statusCode"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>statusCode</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="statusDesc"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>statusDesc</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="txnDate"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>txnDate</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="last undefined">
                                <td
                                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                                  kind="field"
                                  title="orderRefNo"
                                >
                                  <span class="sc-iemWCZ fhDkLh"></span>
                                  <span>orderRefNo</span>
                                </td>
                                <td class="sc-bkbkJK gmOLLi">
                                  <div>
                                    <div>
                                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                        string
                                      </span>
                                    </div>
                                    <div>
                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="sc-iwajpm bcEyfL"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 9) {
      return (
        <div id="getBene" class="mt-10">
          <h3>fetchBalanceResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtythree}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionSixtythree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtythree && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtyfour}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionSixtyfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtyfour && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as "GPWB"</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtyfive}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionSixtyfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtyfive && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtysix}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    preLoadingWallet{" "}
                    {ShowHideAccordionSixtysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtysix && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="walletType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>walletType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="finalBal"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>finalBal</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 10) {
      return (
        <div id="getBene" class="mt-10">
          <h3>fetchOtherBalanceResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtyseven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionSixtyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtyseven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtyeight}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionSixtyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtyeight && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as "GPWB"</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSixtynine}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionSixtynine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSixtynine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventy}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    preLoadingWallet{" "}
                    {ShowHideAccordionSeventy ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventy && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="finalBal"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>finalBal</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 11) {
      return (
        <div id="getBene" class="mt-10">
          <h3>fetchOtherBalanceRequest</h3>
          <table class="table">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span>header</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table nested-table">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                  kind="field"
                  title="operatingSystem"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>operatingSystem</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        string
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                        <p>Pass value “android” or “ios” in this field.</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                  kind="field"
                  title="sessionId"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>sessionId</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        string
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                        <p>AggId or sessionId getting in response</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                  kind="field"
                  title="version"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>version</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        string
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span>userInfo</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span>transaction</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table nested-table">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                  kind="field"
                  title="requestType"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>requestType</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        string
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                        <p>Pass value as WTW</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                  kind="field"
                  title="requestSubType"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>requestSubType</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        string
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                        <p>Pass value as "GPWB"</p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                  kind="field"
                  title="id"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>id</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        string
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                >
                  <span>preLoadingWallet</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table nested-table">
            <tbody>
              <tr class="last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                  kind="field"
                  title="walletType"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>walletType</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        string
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    } else {
      return <div>No Data</div>;
    }
  };
  //
  //
  //
  const ShowFourTab2 = () => {
    if (FourTabSelect == 1) {
      return (
        <div id="versionCheck" class="mt-10">
          <h3>addBeneficiaryRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventyone}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionSeventyone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventyone && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Send Aggregator Id or sessionId if getting
                                      in response.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>userInfo</span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideSeventytwo}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionSeventytwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventytwo && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “BENEF”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideSeventythree}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionSeventythree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventythree && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Account No</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Bank IFSC code</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="nickName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>nickName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Nick Name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 2) {
      return (
        <div id="loadMoney" class="mt-10">
          <h3>payoutAPIRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventyfour}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionSeventyfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventyfour && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” or "WEB" in
                                      this parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Send Aggregator Id or sessionId getting in
                                      response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventyfive}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionSeventyfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventyfive && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “PBENE”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="tranCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>tranCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventysix}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionSeventysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventysix && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="beneId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>beneId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 3) {
      return (
        <div id="loadMoneyList" class="mt-10">
          <h3>transactionStatusCheckReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr>
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventyseven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionSeventyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventyseven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventyeight}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionSeventyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventyeight && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “STCHK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideSeventynine}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionSeventynine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionSeventynine && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="payoutId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>payoutId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass the payout id for which you intend to
                                      know the final status
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else {
      return <div>No Data</div>;
    }
  };
  //
  //
  //
  const ShowFourTab3 = () => {
    if (FourTabSelect == 1) {
      return (
        <div id="versionCheck" class="mt-10">
          <h3>addBeneficiaryResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEighty}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionEighty ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEighty && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Send Aggregator Id or sessionId if getting
                                      in response.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideEightyone}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionEightyone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightyone && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="surChargeAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>surChargeAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideEightytwo}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionEightytwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightytwo && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideEightythree}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionEightythree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightythree && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="payoutId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>payoutId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Account No</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Bank IFSC code</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="aggregatorId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>aggregatorId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="spkRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>spkRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusDesc"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusDesc</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 2) {
      return (
        <div id="loadMoney" class="mt-10">
          <h3>payoutAPIResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEightyfour}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionEightyfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightyfour && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="version"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>version</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEightyfive}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionEightyfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightyfive && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEightysix}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionEightysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightysix && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEightyseven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionEightyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightyseven && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="payoutId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>payoutId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Account No</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Bank IFSC code</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="aggregatorId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>aggregatorId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene Name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="spkRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>spkRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Bene add type</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusDesc"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusDesc</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnDate"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnDate</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 3) {
      return (
        <div id="loadMoneyList" class="mt-10">
          <h3>transactionStatusCheckRes</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEightyeight}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionEightyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightyeight && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideEightynine}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionEightynine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionEightynine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “STCHK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNinety}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionNinety ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinety && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNinetyone}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionNinetyone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetyone && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="payoutId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>payoutId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Transaction Amount.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Bank Account no in which amount will be
                                      credited.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IFSC Code</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Name of Bank</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IMPS, UPI</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="aggregatorId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>aggregatorId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Saving, Current</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusDesc"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusDesc</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="orderRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>orderRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else {
      return <div>No Data</div>;
    }
  };
  //
  //
  const ShowFourTab4 = () => {
    if (FourTabSelect == 1) {
      return (
        <div id="versionCheck" class="mt-10">
          <h3>payoutWithoutBeneRequest</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNinetytwo}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionNinetytwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetytwo && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideNinetythree}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionNinetythree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetythree && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “PYOUT”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideNinetyfour}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionNinetyfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetyfour && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Transaction Amount.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Bank Account no in which amount will be
                                      credited.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IFSC Code (11 Characters only)</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Name of Bank without spaces (eg:HDFCBank)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Paymode with which transaction should
                                      happen: IMPS, UPI
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 2) {
      return (
        <div id="loadMoney" class="mt-10">
          <h3>payoutWithoutBeneWithoutOTPReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNinetyfive}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionNinetyfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetyfive && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass Value “android” or “ios” in this
                                      parameter.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNinetysix}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionNinetysix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetysix && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “PYOUT”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Send in serviceReqRes</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNinetyseven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionNinetyseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetyseven && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Transaction Amount.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Bank Account no in which amount will be
                                      credited.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IFSC Code (11 Characters only)</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Name of Bank without spaces (eg:HDFCBank)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Paymode with which transaction should
                                      happen: IMPS, UPI
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 3) {
      return (
        <div id="loadMoneyList" class="mt-10">
          <h3>transactionStatusCheckReq</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNinetyeight}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionNinetyeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetyeight && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideNinetynine}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionNinetynine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionNinetynine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “STCHK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundred}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionHundred ? <FaAngleDown /> : <FaAngleUp />}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundred && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="payoutId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>payoutId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass the payout id for which you intend to
                                      know the final status
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else {
      return <div>No Data</div>;
    }
  };
  //
  //
  const ShowFourTab5 = () => {
    if (FourTabSelect == 1) {
      return (
        <div id="versionCheck" class="mt-10">
          <h3>payoutWithoutBeneResponse</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundredone}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionHundredone ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredone && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="date"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>date</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideHundredtwo}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionHundredtwo ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredtwo && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “PYOUT”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="agId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>agId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="transAmt"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>transAmt</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="otp_ref_number"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>otp_ref_number</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="id"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>id</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Send in serviceReqRes</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="surChargeAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>surChargeAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideHundredthree}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionHundredthree ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredthree && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr class="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="transaction"
                  onClick={onClickAccordianShowHideHundredfour}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionHundredfour ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredfour && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Transaction Amount.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Bank Account no in which amount will be
                                      credited.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IFSC Code (11 Characters only)</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Name of Bank without spaces (eg:HDFCBank)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Paymode with which transaction should
                                      happen: IMPS, UPI
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 2) {
      return (
        <div id="loadMoney" class="mt-10">
          <h3>payoutWithoutBeneWithoutOTPRes</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundredfive}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionHundredfive ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredfive && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ipAddress"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ipAddress</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userAgent"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userAgent</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundredsix}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionHundredsix ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredsix && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “WTW”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “PYOUT”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="surChargeAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>surChargeAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundredseven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionHundredseven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredseven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundredeight}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionHundredeight ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredeight && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Transaction Amount.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Bank Account no in which amount will be
                                      credited.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IFSC Code (11 Characters only)</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Name of Bank without spaces (eg:HDFCBank)
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Paymode with which transaction should
                                      happen: IMPS, UPI
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (FourTabSelect == 3) {
      return (
        <div id="loadMoneyList" class="mt-10">
          <h3>transactionStatusCheckRes</h3>
          <table class="sc-hHEiqL iZJLLY">
            <tbody>
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundrednine}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    header{" "}
                    {ShowHideAccordionHundrednine ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundrednine && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="operatingSystem"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>operatingSystem</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Pass value “android” or “ios” in this
                                      field.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="sessionId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>sessionId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      AggId or sessionId getting in response
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundredten}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    transaction{" "}
                    {ShowHideAccordionHundredten ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredten && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “TMH”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="requestSubType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>requestSubType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Pass value as “STCHK”</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="channel"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>channel</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="uId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>uId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="userId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>userId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundredeleven}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    response{" "}
                    {ShowHideAccordionHundredeleven ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredeleven && (
                <tr className="expanded">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="code"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>code</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="description"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>description</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="expanded last undefined">
                <td
                  class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz"
                  kind="field"
                  title="header"
                  onClick={onClickAccordianShowHideHundredtwelve}
                >
                  <span class="sc-iemWCZ fhDkLh"></span>
                  <span>
                    payOutBean{" "}
                    {ShowHideAccordionHundredtwelve ? (
                      <FaAngleDown />
                    ) : (
                      <FaAngleUp />
                    )}
                  </span>
                </td>
                <td class="sc-bkbkJK gmOLLi">
                  <div>
                    <div>
                      <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                        object
                      </span>
                    </div>
                    <div>
                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                    </div>
                  </div>
                </td>
              </tr>
              {ShowHideAccordionHundredtwelve && (
                <tr className="expanded last undefined">
                  <td colspan="2" className="sc-fnVZcZ dMYtew hmqpxx">
                    <div className="sc-dIvrsQ kPKTxr">
                      <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="payoutId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>payoutId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="mobileNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>mobileNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register mobile no.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="customerId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>customerId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnAmount"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnAmount</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Transaction Amount.</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>
                                      Bank Account no in which amount will be
                                      credited.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="ifscCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>ifscCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IFSC Code</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Name of Bank</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountHolderName"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountHolderName</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Users register name</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>IMPS, UPI</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="aggregatorId"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>aggregatorId</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="accountType"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>accountType</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Saving, Current</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="txnStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>txnStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="bankStatus"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>bankStatus</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusCode"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusCode</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="statusDesc"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>statusDesc</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="last undefined">
                            <td
                              class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                              kind="field"
                              title="orderRefNo"
                            >
                              <span class="sc-iemWCZ fhDkLh"></span>
                              <span>orderRefNo</span>
                            </td>
                            <td class="sc-bkbkJK gmOLLi">
                              <div>
                                <div>
                                  <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                  <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                                    string
                                  </span>
                                </div>
                                <div>
                                  <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    } else {
      return <div>No Data</div>;
    }
  };
  //
  const onclickFourTab = (data) => {
    SetFourTabSelect(data);
  };
  return (
    <div class="idocs-content">
      <div class="row">
        <div class="col-md-12">
          <div
            style={{
              color: "#fff !important",
              backgroundColor: "#263f91",
              height: "150px",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                color: "#fff",
                //  float: "left",
                //  paddingLeft: "140px",
                paddingTop: "30px",
                lineHeight: "30px",
              }}
            >
              Safexpay Payout<br></br>
              API Documentation
            </h3>
            {/* <p style={{ color: "#fff", float: "left", paddingLeft: "340px", top: "55px", position: "absolute", lineHeight: "15px" }}>
         Help about safexpay products and APIs <br></br>to start using our products quickly.
         </p> */}
          </div>
        </div>
      </div>
      <div class="container">
        {/* <div class="row">
      <div class="col-md-8">
         <section id="idocs_content">
            <h1>Payout Solution</h1>
            <hr />
         </section>
      </div>
      <div class="col-md-4 extreme-rt-div">
      </div>
   </div> */}
        <div class="row">
          <div class="col-md-8 mt-20">
            <section id="idocs_accordion1">
              <h2>Introduction</h2>
              <hr />
              <p class="mt-30">
                This guide demonstrates integration flow and Payout APIs.
              </p>
              <div>
                <h5 class="mt-30">
                  Important Information required at Client’s end to start
                  Integration{" "}
                </h5>

                <ol>
                  <li>Customer ID (User ID) shared by Safexpay’s</li>
                  <li>Encryption & Decryption Format</li>
                  <li>Response codes</li>
                </ol>

                <p class="mt-10">
                  Kindly note UAT environment remains closed from 10:30 PM IST
                  To 10:00 AM IST on all days of the week and entire shutdown on
                  every Sunday.
                </p>
              </div>
              <div>
                <h5 class="mt-30">
                  Important Information required to be shared by Client to start
                  Integration{" "}
                </h5>

                <ol>
                  <li>
                    I.P. Addresses for Whitelisting purpose for both UAT and
                    Production environment{" "}
                  </li>
                  <li>
                    Email-id and mobile number for communication and sharing of
                    system generated key for the client on UAT and production.{" "}
                  </li>
                </ol>
              </div>
              <div>
                <h5 class="mt-30">UAT environment testing flow:</h5>

                <ol>
                  <li>
                    {" "}
                    Safexpay will onboard the client and share the following
                    details with client (User ID, posting URLs, system generated
                    integration Secret key){" "}
                  </li>
                  <li>
                    Client should share IP Address for Whitelisting purpose. API
                    requests will be allowed only through Whitelisted IPs.{" "}
                  </li>
                </ol>
              </div>
              <div>
                <h5 class="mt-30">Production environment testing flow:</h5>

                <ol>
                  <li>
                    Safexpay will onboard the client and share the following
                    details with client (UserID, posting URLs){" "}
                  </li>
                  <li>
                    Safexpay will share the merchant individual integration key
                    to the registered email id of the userId.{" "}
                  </li>
                  <li>
                    Client should share IP Address for Whitelisting purpose. All
                    API requests will be allowed only through Whitelisted Ips.{" "}
                  </li>
                  <li>
                    Client should pre-fund the Safexpay Virtual Account which is
                    shared by Safexpay for transfer money. Client needs to
                    transfer funds through the whitelisted account only.{" "}
                  </li>
                  <li>
                    Once funds are available in the Client’s virtual account,
                    client can consume payout APIs{" "}
                  </li>
                  <li>
                    Any request coming via API based upon request type
                    IMPS/NEFT/RTGS, Safexpay will validate that and process the
                    same.{" "}
                  </li>
                  <li>
                    Depending on the payment type, credit will happen to the
                    customer as mentioned in the below table for reference.{" "}
                  </li>
                </ol>
              </div>
              <table class="table table-bordered table-responsive mt-40">
                <tbody>
                  <tr>
                    <td>Transaction Limit/Timing</td>
                    <td>
                      RTGS 04:00 hrs to 17:30 hrs Monday to Saturday (except 2nd
                      & 4th Saturday and banking holidays)
                    </td>
                    <td>IMPS (24x7-365 days) </td>
                    <td>NEFT 04:00 hrs to 17:30 hrs </td>
                    <td>NEFT 17:31 hrs to 03:59 hrs</td>
                    <td>UPI (24x7-365 days)</td>
                  </tr>
                  <tr>
                    <td>Minimum</td>
                    <td>₹ 2 lacs </td>
                    <td>₹ 1</td>
                    <td>₹ 1</td>
                    <td>₹ 1</td>
                    <td>₹ 1</td>
                  </tr>
                  <tr>
                    <td>Maximum</td>
                    <td>₹ 20 lacs</td>
                    <td>₹ 5 lacs</td>
                    <td>₹ 10 lac</td>
                    <td>₹ 2 lacs</td>
                    <td>₹ 1 lac</td>
                  </tr>
                </tbody>
              </table>
              <p class="mt-30">
                *Table showing minimum and maximum limits for different pay
                modes.
              </p>
            </section>
          </div>

          <div class="col-md-12">
            <div>
              <h5 class="mt-30">API Process Flow: </h5>

              <div>
                <img
                  src="/assets/images/api-flow-process-img.png"
                  className="api-process-flow-image"
                />
              </div>

              <div class="mt-10">
                <p style={{ marginBottom: "7px !important", fontWeight: 600 }}>
                  APIs to call in sequence{" "}
                </p>
                <ol>
                  <li>Add Beneficiary</li>
                  <li>Payout with Beneficiary</li>
                  <li>Transaction Status check</li>
                </ol>
              </div>

              <div>
                <p style={{ marginBottom: "7px !important", fontWeight: 600 }}>
                  Supporting APIs{" "}
                </p>
                <ol>
                  <li>Get transaction</li>
                  <li>Get Load money list</li>
                  <li>Balance fetch</li>
                </ol>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div>
              <h5 class="mt-30">Important Points: </h5>
              <ol>
                <li>
                  All APIs are in JSON format and AES 256 encryption &
                  decryption is used for the payload request and response for
                  encoding and decoding.{" "}
                </li>
                <li>
                  Merchant will receive a unique Encryption key which will be
                  used for encryption and decryption of all the API requests.{" "}
                </li>
                <li>
                  Payout request will be sent to the POST URL which will be
                  provided at the time of onboarding.{" "}
                </li>
                <li>Subsequent APIs will be called as required. </li>
              </ol>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 mt-20">
            <h2 id="support-api-sec">Support APIs</h2>
            <hr />
          </div>
          <div class="col-md-8">
            <section id="idocs_accordion1">
              <p>
                Request Url(UAT):{" "}
                <span class="col-red">
                  {/* https://disbursaltwo.safexpay.com/agWalletAPI/v2/agg */}
                  https://neodev2.safexpay.com/agWalletAPI/v2/agg
                </span>
              </p>
              <h6 class="col-gray">
                <u>AUTHORIZATIONS:</u>
              </h6>
              <h6 class="col-gray mt-10">HEADER PARAMETERS</h6>
              <hr class="hr-col" />
              <table class="sc-hHEiqL iZJLLY">
                <tbody>
                  <tr>
                    <td
                      kind="field"
                      title="Content-Type"
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                    >
                      <span className="sc-iemWCZ fhDkLh"></span>
                      <span>Content-Type</span>
                      <div class="col-red1 sc-TtZnY sc-jHNicF ehnWxS imjMKL">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td>
                      <div>
                        <div>
                          <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>application/json</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                      kind="field"
                      title="userId"
                    >
                      <span class="sc-iemWCZ fhDkLh"></span>
                      <span>userId</span>
                      <div class="col-red1 sc-TtZnY sc-jHNicF ehnWxS imjMKL">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td class="">
                      <div>
                        <div>
                          <span class=""></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>
                              This contains encrypted userId with AES encryption
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="last undefined">
                    <td
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                      kind="field"
                      title="sessionKey"
                    >
                      <span class="sc-iemWCZ fhDkLh"></span>
                      <span>sessionKey</span>
                      <div class="col-red1 sc-TtZnY sc-jHNicF ehnWxS imjMKL">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td class="sc-bkbkJK gmOLLi">
                      <div>
                        <div>
                          <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>
                              This contains will get in response after login.
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h6 class="col-gray mt-10">
                <span class="col-gray">REQUEST BODY SCHEMA: </span>{" "}
                <span style={{ color: "#313131" }}>application/json</span>
              </h6>
              <hr class="hr-col" />
              <p class="col-red1" style={{ marginBottom: "0px" }}>
                One of
              </p>
              <div class="tab">
                {/* <button
                  type="button"
                  class="tablinks"
                  id="1"
                  name="1"
                  onClick={(e) => {
                    onclickFourTab(1);
                  }}
                >
                  versionCheckRequest
                </button> */}
                <button
                  type="button"
                  class="tablinks"
                  id="2"
                  name="2"
                  onClick={(e) => {
                    onclickFourTab(2);
                  }}
                >
                  loadMoneyRequest
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="3"
                  name="3"
                  onClick={(e) => {
                    onclickFourTab(3);
                  }}
                >
                  loadMoneyListRequest
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="4"
                  name="4"
                  onClick={(e) => {
                    onclickFourTab(4);
                  }}
                >
                  getBeneficiaryListRequest
                </button>
                {/* <button
                  type="button"
                  class="tablinks"
                  id="5"
                  name="5"
                  onClick={(e) => {
                    onclickFourTab(5);
                  }}
                >
                  validateOTPReq
                </button> */}
                <button
                  type="button"
                  class="tablinks"
                  id="6"
                  name="6"
                  onClick={(e) => {
                    onclickFourTab(6);
                  }}
                >
                  transactionsByDayReq
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="7"
                  name="7"
                  onClick={(e) => {
                    onclickFourTab(7);
                  }}
                >
                  transactionsByCustomerIdReq
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="8"
                  name="8"
                  onClick={(e) => {
                    onclickFourTab(8);
                  }}
                >
                  transactionsByTransactionIdReq
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="9"
                  name="9"
                  onClick={(e) => {
                    onclickFourTab(9);
                  }}
                >
                  transactionStatusCheckReq
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="10"
                  name="10"
                  onClick={(e) => {
                    onclickFourTab(10);
                  }}
                >
                  fetchBalanceRequest
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="11"
                  name="11"
                  onClick={(e) => {
                    onclickFourTab(11);
                  }}
                >
                  fetchOtherBalanceRequest
                </button>
              </div>
              {ShowFourTab()}
            </section>
          </div>
          <div class="col-md-4 extreme-rt-div mt-40">
            <div
              class="accordion accordion-alterate arrow-right side-api"
              id="popularTopics"
            >
              <div class="card mt-30">
                <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                    <div
                      style={{
                        backgroundColor: "rgb(17 23 26)",
                        color: "#fff",
                      }}
                      onClick={onClickCangeTab}
                    >
                      <button> POST </button> /agWalletAPI/v2/agg/3{" "}
                      {TabCheck ? <FaAngleUp /> : <FaAngleDown />}
                    </div>
                  </h5>
                </div>
                {TabCheck && (
                  <div>
                    <br />
                    <div class="card-body">
                      <p class="mb-0">Production server (uses live data)</p>
                      {/* <div class="api-div-bor">
                        <span>https://payout.safexpay.com</span>
                        <span class="col-org">/agWalletAPI/v2/agg/3</span>
                      </div> */}
                      <div class="api-div-bor">
                        <span>https://neodev2.safexpay.com/</span>
                        <span class="col-org">/agWalletAPI/v2/agg</span>
                      </div>
                      <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                      {/* <div class="api-div-bor">
                        <span>https://disbursaltwo.safexpay.com</span>
                        <span class="col-org">/agWalletAPI/v2/agg/3</span>
                      </div> */}
                       <div class="api-div-bor">
                       <span>https://neodev2.safexpay.com/</span>
                        <span class="col-org">/agWalletAPI/v2/agg</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <RequestJSON />
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 mt-30">
            <h5>Responses</h5>
            <div
              class="accordion accordion-alterate arrow-right mt-30"
              id="popularTopics"
            >
              <div class="card">
                <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                    <div
                      style={{
                        backgroundColor: "rgba(29, 129, 39, 0.07)",
                        color: "rgb(29, 129, 39)",
                        padding: "10px 15px",
                      }}
                      onClick={onClickCangeTab1}
                    >
                      <b>200</b> A refund response json object{" "}
                      {TabCheck1 ? <FaAngleUp /> : <FaAngleDown />}
                    </div>
                  </h5>
                </div>
                {TabCheck1 && (
                  <div>
                    <div class="card-body">
                      <h6 class="col-gray mt-10">
                        <span class="col-gray">REQUEST BODY SCHEMA: </span>{" "}
                        <span style={{ color: "#313131" }}>
                          application/json
                        </span>
                      </h6>
                      <hr class="hr-col"></hr>
                      <p class="col-red1" style={{ marginBottom: "0px" }}>
                        One of
                      </p>
                      <div class="tab">
                        <button
                          type="button"
                          class="tablinks"
                          id="1"
                          name="1"
                          onClick={(e) => {
                            onclickFourTab(1);
                          }}
                        >
                          versionCheckResponse
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="2"
                          name="2"
                          onClick={(e) => {
                            onclickFourTab(2);
                          }}
                        >
                          loadMoneyResponse
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="3"
                          name="3"
                          onClick={(e) => {
                            onclickFourTab(3);
                          }}
                        >
                          loadMoneyListResponse
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="4"
                          name="4"
                          onClick={(e) => {
                            onclickFourTab(4);
                          }}
                        >
                          getBeneficiaryListResponse
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="5"
                          name="5"
                          onClick={(e) => {
                            onclickFourTab(5);
                          }}
                        >
                          validateOTPRes
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="6"
                          name="6"
                          onClick={(e) => {
                            onclickFourTab(6);
                          }}
                        >
                          transactionsByDayRes
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="7"
                          name="7"
                          onClick={(e) => {
                            onclickFourTab(7);
                          }}
                        >
                          transactionsByCustomerIdRes
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="8"
                          name="8"
                          onClick={(e) => {
                            onclickFourTab(8);
                          }}
                        >
                          transactionsByTransactionIdRes
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="9"
                          name="9"
                          onClick={(e) => {
                            onclickFourTab(9);
                          }}
                        >
                          fetchBalanceResponse
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="10"
                          name="10"
                          onClick={(e) => {
                            onclickFourTab(10);
                          }}
                        >
                          fetchOtherBalanceResponse
                        </button>
                      </div>
                      {ShowFourTab1()}
                    </div>
                  </div>
                )}
              </div>
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>400 Bad request</span>{" "}
                  </h5>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>401 Unauthorized</span>{" "}
                  </h5>
                </div>
              </div>
              <div class="card mb-60">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>404 Not found</span>{" "}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 extreme-rt-div">
            <ResponseJSON />
          </div>
        </div>
        {/* <hr class="hr-seperator"></hr> */}

        <div class="row mt-50">
          <div class="col-md-8">
            <h2 id="transaction-flow-sec">Transaction Initiation Flow</h2>
            <hr />
          </div>
          <div class="col-md-8">
            <section id="idocs_tabs1">
              <h6 class="col-gray">
                <u>AUTHORIZATIONS:</u>
              </h6>
              <h6 class="col-gray mt-10">HEADER PARAMETERS</h6>
              <hr class="hr-col" />
              <table class="sc-hHEiqL iZJLLY">
                <tbody>
                  <tr>
                    <td
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                      kind="field"
                      title="Content-Type"
                    >
                      <span class="sc-iemWCZ fhDkLh"></span>
                      <span>Content-Type</span>
                      <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL col-red1">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td class="sc-bkbkJK gmOLLi">
                      <div>
                        <div>
                          <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>application/json</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                      kind="field"
                      title="userId"
                    >
                      <span class="sc-iemWCZ fhDkLh"></span>
                      <span>userId</span>
                      <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL col-red1">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td class="sc-bkbkJK gmOLLi">
                      <div>
                        <div>
                          <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>
                              This contains encrypted userId with AES encryption
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="last undefined">
                    <td
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                      kind="field"
                      title="sessionKey"
                    >
                      <span class="sc-iemWCZ fhDkLh"></span>
                      <span>sessionKey</span>
                      <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL col-red1">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td class="sc-bkbkJK gmOLLi">
                      <div>
                        <div>
                          <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>
                              This contains will get in response after login.
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h6 class="col-gray mt-10">
                <span class="col-gray">REQUEST BODY SCHEMA: </span>{" "}
                <span style={{ color: "#313131" }}>application/json</span>
              </h6>
              <hr class="hr-col"></hr>
              <p class="col-red1" style={{ marginBottom: "0px" }}>
                One of
              </p>
              <div class="tab">
                <button
                  type="button"
                  class="tablinks"
                  id="1"
                  name="1"
                  onClick={(e) => {
                    onclickFourTab(1);
                  }}
                >
                  addBeneficiaryRequest
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="2"
                  name="2"
                  onClick={(e) => {
                    onclickFourTab(2);
                  }}
                >
                  payoutAPIRequest
                </button>
                <button
                  type="button"
                  class="tablinks"
                  id="3"
                  name="3"
                  onClick={(e) => {
                    onclickFourTab(3);
                  }}
                >
                  transactionStatusCheckReq
                </button>
              </div>
              {ShowFourTab2()}
            </section>
          </div>
          <div class="col-md-4 extreme-rt-div mt-40">
            <div
              class="accordion accordion-alterate arrow-right side-api"
              id="popularTopics"
            >
              <div class="card mt-30">
                <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                    <div
                      style={{
                        backgroundColor: "rgb(17 23 26)",
                        color: "#fff",
                      }}
                      onClick={onClickCangeTab6}
                    >
                      <button> POST </button> /agWalletAPI/v2/agg/1{" "}
                      {TabCheck6 ? <FaAngleUp /> : <FaAngleDown />}
                    </div>
                  </h5>
                </div>
                {TabCheck6 && (
                  <div>
                    <br />
                    <div class="card-body">
                      <p class="mb-0">Production server (uses live data)</p>
                      <div class="api-div-bor">
                        <span>https://payout.safexpay.com</span>
                        <span class="col-org">/agWalletAPI/v2/agg/1</span>
                      </div>
                      <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                      <div class="api-div-bor">
                        <span>https://disbursaltwo.safexpay.com</span>
                        <span class="col-org">/agWalletAPI/v2/agg/1</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <RequestJSONflowone />
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 mt-30">
            <h5>Responses</h5>
            <div
              class="accordion accordion-alterate arrow-right mt-30"
              id="popularTopics"
            >
              <div class="card">
                <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                    <div
                      style={{
                        backgroundColor: "rgba(29, 129, 39, 0.07)",
                        color: "rgb(29, 129, 39)",
                        padding: "10px 15px",
                      }}
                      onClick={onClickCangeTab2}
                    >
                      <b>200</b> A refund response json object{" "}
                      {TabCheck2 ? <FaAngleUp /> : <FaAngleDown />}
                    </div>
                  </h5>
                </div>
                {TabCheck2 && (
                  <div>
                    <div class="card-body">
                      <h6 class="col-gray mt-10">
                        <span class="col-gray">REQUEST BODY SCHEMA: </span>{" "}
                        <span style={{ color: "#313131" }}>
                          application/json
                        </span>
                      </h6>
                      <hr class="hr-col"></hr>
                      <p class="col-red1" style={{ marginBottom: "0px" }}>
                        One of
                      </p>
                      <div class="tab">
                        <button
                          type="button"
                          class="tablinks"
                          id="1"
                          name="1"
                          onClick={(e) => {
                            onclickFourTab(1);
                          }}
                        >
                          addBeneficiaryResponse
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="2"
                          name="2"
                          onClick={(e) => {
                            onclickFourTab(2);
                          }}
                        >
                          payoutAPIResponse
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="3"
                          name="3"
                          onClick={(e) => {
                            onclickFourTab(3);
                          }}
                        >
                          transactionStatusCheckRes
                        </button>
                      </div>
                      {ShowFourTab3()}
                    </div>
                  </div>
                )}
              </div>
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>400 Bad request</span>{" "}
                  </h5>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>401 Unauthorized</span>{" "}
                  </h5>
                </div>
              </div>
              <div class="card mb-60">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>404 Not found</span>{" "}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 extreme-rt-div">
            <ResponseJSONflowone />
          </div>
        </div>
        {/* <hr class="hr-seperator"></hr> */}
        {/* <div class="row">
          <div class="col-md-8 mt-60">
            <section id="idocs_social_icon1">
              <h2>Transaction Initiation Flow 2</h2>
              <hr />
              <h6 class="col-gray">
                <u>AUTHORIZATIONS:</u>
              </h6>
              <h6 class="col-gray mt-10">HEADER PARAMETERS</h6>
              <hr class="hr-col" />
              <table class="sc-hHEiqL iZJLLY">
                <tbody>
                  <tr>
                    <td
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                      kind="field"
                      title="Content-Type"
                    >
                      <span class="sc-iemWCZ fhDkLh"></span>
                      <span>Content-Type</span>
                      <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL col-red1">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td class="sc-bkbkJK gmOLLi">
                      <div>
                        <div>
                          <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>application/json</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                      kind="field"
                      title="userId"
                    >
                      <span class="sc-iemWCZ fhDkLh"></span>
                      <span>userId</span>
                      <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL col-red1">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td class="sc-bkbkJK gmOLLi">
                      <div>
                        <div>
                          <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>
                              This contains encrypted userId with AES encryption
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="last undefined">
                    <td
                      class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS"
                      kind="field"
                      title="sessionKey"
                    >
                      <span class="sc-iemWCZ fhDkLh"></span>
                      <span>sessionKey</span>
                      <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL col-red1">
                        {" "}
                        required{" "}
                      </div>
                    </td>
                    <td class="sc-bkbkJK gmOLLi">
                      <div>
                        <div>
                          <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                          <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">
                            string
                          </span>
                        </div>
                        <div>
                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                            <p>
                              This contains will get in response after login.
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
          <div class="col-md-4 extreme-rt-div">
            <div
              class="accordion accordion-alterate arrow-right mt-60 side-api"
              id="popularTopics"
            >
              <div class="card">
                <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                    <div
                      style={{
                        backgroundColor: "rgb(17 23 26)",
                        color: "#fff",
                      }}
                      onClick={onClickCangeTab7}
                    >
                      <button> POST </button> /agWalletAPI/v2/agg/2{" "}
                      {TabCheck7 ? <FaAngleUp /> : <FaAngleDown />}
                    </div>
                  </h5>
                </div>
                {TabCheck7 && (
                  <div>
                    <br />
                    <div class="card-body">
                      <p class="mb-0">Production server (uses live data)</p>
                      <div class="api-div-bor">
                        <span>https://payout.safexpay.com</span>
                        <span class="col-org">/agWalletAPI/v2/agg/2</span>
                      </div>
                      <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                      <div class="api-div-bor">
                        <span>https://disbursaltwo.safexpay.com</span>
                        <span class="col-org">/agWalletAPI/v2/agg/2</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <RequestJSONflowtwo />
            <ResponseJSONflowtwo />
          </div>
        </div>
        <div className="row">
          <div class="col-md-8">
            <h6 class="col-gray mt-10">
              <span class="col-gray">REQUEST BODY SCHEMA: </span>{" "}
              <span style={{ color: "#313131" }}>application/json</span>
            </h6>
            <hr class="hr-col"></hr>
            <p class="col-red1" style={{ marginBottom: "0px" }}>
              One of
            </p>
            <div class="tab">
              <button
                type="button"
                class="tablinks"
                id="1"
                name="1"
                onClick={(e) => {
                  onclickFourTab(1);
                }}
              >
                payoutWithoutBeneRequest
              </button>
              <button
                type="button"
                class="tablinks"
                id="2"
                name="2"
                onClick={(e) => {
                  onclickFourTab(2);
                }}
              >
                payoutWithoutBeneWithoutOTPReq
              </button>
              <button
                type="button"
                class="tablinks"
                id="3"
                name="3"
                onClick={(e) => {
                  onclickFourTab(3);
                }}
              >
                transactionStatusCheckReq
              </button>
            </div>
            {ShowFourTab4()}
          </div>
          <div className="col-md-4 extreme-rt-div"></div>
        </div>
        <div class="row">
          <div class="col-md-8 mt-30">
            <h5>Responses</h5>
            <div
              class="accordion accordion-alterate arrow-right mt-30"
              id="popularTopics"
            >
              <div class="card">
                <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                    <div
                      style={{
                        backgroundColor: "rgba(29, 129, 39, 0.07)",
                        color: "rgb(29, 129, 39)",
                        padding: "10px 15px",
                      }}
                      onClick={onClickCangeTab5}
                    >
                      <b>200</b> A refund response json object{" "}
                      {TabCheck5 ? <FaAngleUp /> : <FaAngleDown />}
                    </div>
                  </h5>
                </div>
                {TabCheck5 && (
                  <div>
                    <div class="card-body">
                      <h6 class="col-gray mt-10">
                        <span class="col-gray">REQUEST BODY SCHEMA: </span>{" "}
                        <span style={{ color: "#313131" }}>
                          application/json
                        </span>
                      </h6>
                      <hr class="hr-col"></hr>
                      <p class="col-red1" style={{ marginBottom: "0px" }}>
                        One of
                      </p>
                      <div class="tab">
                        <button
                          type="button"
                          class="tablinks"
                          id="1"
                          name="1"
                          onClick={(e) => {
                            onclickFourTab(1);
                          }}
                        >
                          payoutWithoutBeneResponse
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="2"
                          name="2"
                          onClick={(e) => {
                            onclickFourTab(2);
                          }}
                        >
                          payoutWithoutBeneWithoutOTPRes
                        </button>
                        <button
                          type="button"
                          class="tablinks"
                          id="3"
                          name="3"
                          onClick={(e) => {
                            onclickFourTab(3);
                          }}
                        >
                          transactionStatusCheckRes
                        </button>
                      </div>
                      {ShowFourTab5()}
                    </div>
                  </div>
                )}
              </div>
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>400 Bad request</span>{" "}
                  </h5>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>401 Unauthorized</span>{" "}
                  </h5>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">
                    {" "}
                    <span>404 Not found</span>{" "}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 extreme-rt-div"></div>
        </div> */}
      </div>
    </div>
  );
}
export default PayoutSolution;
